import { render } from "./OrdersListView.vue?vue&type=template&id=49c5ae5c&scoped=true"
import script from "./OrdersListView.vue?vue&type=script&lang=js"
export * from "./OrdersListView.vue?vue&type=script&lang=js"

import "./OrdersListView.vue?vue&type=style&index=0&id=49c5ae5c&scoped=true&lang=css"
import "./OrdersListView.vue?vue&type=style&index=1&id=49c5ae5c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c5ae5c"]])

export default __exports__